import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const PUBLISH_CONDITION_VERSION_MUTATION = gql`
    mutation publishConditionVersion($type: ConditionType!, $versionNumber: Int!) {
        publishConditionVersion(type: $type, versionNumber: $versionNumber) {
            uuid
            type
            publishedVersionNumber
        }
    }
`;

const usePublishConditionVersion = () => {
    const [mutate, { loading, error }] = useMutation(PUBLISH_CONDITION_VERSION_MUTATION);

    const publishConditionVersion = async (type, versionNumber) => {
        return mutate({
            variables: {
                type,
                versionNumber,
            },
        });
    };

    return { publishConditionVersion, loading, error };
};

export default usePublishConditionVersion;
